import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { EditCommandePage } from "@/features/ventes/components/commandes/EditCommandePage";

export const Route = createFileRoute("/_app/ventes/commandes/$id/edit")({
  loader: requirePermission(PERMISSIONS.VENTES.COMMANDES.EDIT),
  staticData: {
    title: "Modifier commande",
    showInBreadcrumb: true,
  },
  component: EditCommandePage,
});
